module.exports = __webpack_public_path__ + "static/media/atlas.c85498ac.svg";